import SaleExpenseForm from "../../SaleExpense/SaleExpenseForm";

const ExpenseForm = () => {
  return <SaleExpenseForm type={"out"} />;
};
export default ExpenseForm;
